export const RootScreens = {
  today: 'todayTab',
  move: 'moveTab',
  mind: 'mindTab',
  chat: 'chatTab',
  browse: 'browseTab',
}
